import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Footer.scss';
import Banner from '../../Images/Banner.png'
import AreaData from '../../Components/ServicesPage/AreaData'

export default function Footer({ CitiePhone, locationsMain }) {
    const Navigate = useNavigate()
    return (
        <div className="Footer">
                <div className="HomePageGoogleFooterTop">
                    <div className="HomePageGoogleFooterTopTitle">
                        <img src={require(`../../Images/Music.png`)} />
                        <h1>Healthy Air, We Truly Care, Master is Rare <br /> Bringing Freshness Everywhere!</h1>
                        <img src={require(`../../Images/Music.png`)} />
                    </div>
                    <div className="HomePageGoogleFooterTopImg">
                        <img src={require(`../../ImagesLogos/Banner1Logo.png`)} />
                    </div>
                </div>
                <div className="FooterTop">
                    <div className="SiteMapDiv">
                        <h1>Master Air Duct</h1>
                        <div className="SiteMapDivList">
                            <a href="/">Home Page</a>
                            <a href="/services">Our Services</a>
                            <a href="/airduct">Air Duct Cleaning</a>
                            <a href="/chimney">Chimney Services</a>
                            <a href="/book">Schedule Online</a>
                            <a href="/sitemap">Site Map</a>
                        </div>
                    </div>
                    <div className="SiteMapDiv">
                        <h1>Privacy</h1>
                        <div className="SiteMapDivList">
                            <a href="/privacy-policy">Privacy Policy</a>
                            <a href="/terms-and-conditions">Terms And Conditions</a>
                        </div>
                    </div>
                    <div className="SiteMapDiv">
                        <h1>Contact Us</h1>
                        <div className="SiteMapDivList">
                            <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                            <a href="mailto:info@masterairducts.com">info@masterairducts.com</a>
                            <a href="https://www.masterairducts.com">www.masterairducts.com</a>
                        </div>
                    </div>
                    <div className="SiteMapDiv">
                        <h1>Services</h1>
                        <div className="SiteMapDivList">
                            {AreaData.map((A, index) =>
                                <a key={index} href={A.Path}>{A.Title}</a>
                            )}
                        </div>
                    </div>
                </div>
                <div className="HomePageGoogleFooterBottom">
                    <div className="HomePageGoogleFooterBottomTop">
                        <img src={require(`../../ImagesLogos/Banner2Logo.png`)} />
                        <div className="Header2LogoName">
                            <h1>MASTER AIR DUCT</h1>
                            <h2>Your Local Air Duct Company</h2>
                        </div>
                        <p>Copyright 2001-2024 Master Air Duct Cleaning. All rights reserved. All available services, hours of operations, pricing structure, and guarantees may vary by location.</p>
                    </div>
                    {locationsMain.find(a => a.Phone == CitiePhone) ?
                        <div className="HomePageGoogleFooterMiddle">
                            {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                                <div key={index} className="HomePageGoogleLocationLeftBox">
                                    <h4>{A.Location1}</h4>
                                    <h5>{A.Address1}</h5>
                                    <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                                </div>
                            )}
                        </div>
                        : null}
                    <div className="HomePageGoogleFooterBottomBottom">
                        <span>
                            <img src={require(`../../Images/ranking.png`)} alt="" />
                            <a>www.masterairducts.com</a>
                        </span>
                        <span>
                            <img src={require(`../../Images/ranking.png`)} alt="" />
                            <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </span>
                        <span>
                            <img src={require(`../../Images/ranking.png`)} alt="" />
                            <a>info@masterairducts.com</a>
                        </span>
                    </div>
                </div>
        </div>
    )
}
